/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 40ad59d7 (Wed Jul 15 19:12:51 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface Notification
 */
export interface Notification {
  /**
   * The unique ID for the notification record.
   * @type number
   * @memberof Notification
   */
  notificationKey?: number
  /**
   * The name of the notification.
   * @type string
   * @memberof Notification
   */
  name: string
  /**
   * The message body for the notification. This will be displayed to the user.
   * @type string
   * @memberof Notification
   */
  body: string
  /**
   * The date and time to begin showing the notification to users.
   * @type Date
   * @memberof Notification
   */
  startDate: Date
  /**
   * The date and time to stop showing the notification to users.
   * @type Date
   * @memberof Notification
   */
  endDate: Date
  /**
   * The color of the notification banner.
   * @type string
   * @memberof Notification
   */
  color: string
  /**
   * A list of region keys that the notification should be shown to. Empty means that it's not limited to a region and should be shown for all regions.
   * @type {Array<number>}
   * @memberof Notification
   */
  regionKeys: Array<number>
  /**
   * A list of role keys that the notification should be shown to. Empty means that it's not limited to a role and should be shown for all roles.
   * @type {Array<number>}
   * @memberof Notification
   */
  roleKeys: Array<number>
}

export function NotificationFromJSON(json: any): Notification {
  return NotificationFromJSONTyped(json, false)
}

export function NotificationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Notification {
  if (json === undefined || json === null) {
    return json
  }
  return {
    notificationKey: !exists(json, 'notificationKey')
      ? undefined
      : json['notificationKey'],
    name: json['name'],
    body: json['body'],
    startDate: new Date(json['startDate']),
    endDate: new Date(json['endDate']),
    color: json['color'],
    regionKeys: json['regionKeys'],
    roleKeys: json['roleKeys'],
  }
}

export function NotificationToJSON(value?: Notification | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    notificationKey: value.notificationKey,
    name: value.name,
    body: value.body,
    startDate: value.startDate.toISOString(),
    endDate: value.endDate.toISOString(),
    color: value.color,
    regionKeys: value.regionKeys,
    roleKeys: value.roleKeys,
  }
}
